import React from 'react';
import authRoles from '../../../auth/authRoles';

const StudentInformation = React.lazy(() => import('./StudentInformation'));
const EditStudent = React.lazy(() => import('../../../fuse-layouts/shared-components/student-form/EditStudent'));
const AddEditContact = React.lazy(() => import('../../../fuse-layouts/shared-components/student-form/AddEditContact'));
const EditMedications = React.lazy(() => import('../../../fuse-layouts/shared-components/student-form/EditMedications'));

const StudentInformationConfig = {
	settings: {
		layout: {
			config: {
				mode: 'fullwidth',
				scroll: 'content',
				navbar: {
					display: true,
					position: 'left',
				},
				toolbar: {
					display: true,
				},
				footer: {
					display: false,
				},
			},
		},
	},
	routes: [
		{
			path: '/students-student/:id',
			element: (
				<React.Suspense fallback={<>...</>}>
					<StudentInformation />
				</React.Suspense>
			),
		},
		{
			path: '/students-editstudent/:id',
			element: (
				<React.Suspense fallback={<>...</>}>
					<EditStudent />
				</React.Suspense>
			),
		},
		{
			path: '/students-contact',
			// component: AddEditContact,
			element: (
				<React.Suspense fallback={<>...</>}>
					<AddEditContact />
				</React.Suspense>
			),
		},
		{
			path: '/students-editmedications',
			// component: EditMedications,
			element: (
				<React.Suspense fallback={<>...</>}>
					<EditMedications />
				</React.Suspense>
			),
		},
	],
	auth: authRoles.subadmin,
};

export default StudentInformationConfig;
